import Legend from "./Legend";
import LegendItem from "./LegendItem";

export { LegendItem };

export default Legend;
